import React from 'react'
import { Button, Row } from '@fs/zion-ui'
import { NoticeLoading } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'

export default function LoadMoreButton({ loading, onClick, centered }) {
  const [t] = useTranslation()
  const button = (
    <Button
      Icon={loading && NoticeLoading}
      emphasis="medium"
      onClick={onClick}
      disabled={loading}
      data-testid="load-more"
    >
      {t('load-more', 'Load More')}
    </Button>
  )
  return centered ? <Row alignX="center">{button}</Row> : button
}
